/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { JobConfigurationDto } from './JobConfigurationDto';
import {
    JobConfigurationDtoFromJSON,
    JobConfigurationDtoFromJSONTyped,
    JobConfigurationDtoToJSON,
} from './JobConfigurationDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfJobConfigurationDto
 */
export interface ODataPostProcessedResultsOfJobConfigurationDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfJobConfigurationDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<JobConfigurationDto>}
     * @memberof ODataPostProcessedResultsOfJobConfigurationDto
     */
    value?: Array<JobConfigurationDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfJobConfigurationDto
     */
    $type?: ODataPostProcessedResultsOfJobConfigurationDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfJobConfigurationDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfJobConfigurationDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoJobConfigurationDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.JobConfigurationDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfJobConfigurationDtoTypeEnum = typeof ODataPostProcessedResultsOfJobConfigurationDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfJobConfigurationDtoTypeEnum];


/**
 * Check if a given object implements the ODataPostProcessedResultsOfJobConfigurationDto interface.
 */
export function instanceOfODataPostProcessedResultsOfJobConfigurationDto(value?: unknown): value is ODataPostProcessedResultsOfJobConfigurationDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfJobConfigurationDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfJobConfigurationDtoFromJSON(json: any): ODataPostProcessedResultsOfJobConfigurationDto {
    return ODataPostProcessedResultsOfJobConfigurationDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfJobConfigurationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfJobConfigurationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'value': !exists(json, 'value') ? undefined : (json['value'] === null ? null : (json['value'] as Array<any>).map(JobConfigurationDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
        'odataCount': !exists(json, '@odata.count') ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfJobConfigurationDtoToJSON(value?: ODataPostProcessedResultsOfJobConfigurationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value.totalCount,
        'value': value.value === undefined ? undefined : (value.value === null ? null : (value.value as Array<any>).map(JobConfigurationDtoToJSON)),
        '$type': value.$type,
        '@odata.count': value.odataCount,
    });
}

